import {axiosInstance} from "../helpers/axios";

const sendSMS = (data) => {
    return axiosInstance.post('sendSMS/', data ).then((res) => {
        const data = res.data;
        return data;
    }).
    catch(err => {
        console.log("error");
        console.log(err.message);
    });
}

export default { sendSMS };